const Account: React.FC = () => {
    return <>Account Page</>;
};
export default Account;
